// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TasksFilterChip-module__tooltip--1aijU","tooltipContent":"TasksFilterChip-module__tooltipContent--1NmmB","option":"TasksFilterChip-module__option--17m8e"};